var map = {
	"./AlienSpaceship.sol/AlienSpaceship.dbg.json": 1234,
	"./AlienSpaceship.sol/AlienSpaceship.json": 1235,
	"./AlienSpaceshipBytecode.sol/AlienSpaceshipBytecode.dbg.json": 1236,
	"./AlienSpaceshipBytecode.sol/AlienSpaceshipBytecode.json": 515,
	"./AlienSpaceshipFactory.sol/AlienSpaceshipFactory.dbg.json": 1237,
	"./AlienSpaceshipFactory.sol/AlienSpaceshipFactory.json": 1238,
	"./Dummy.sol/Dummy.dbg.json": 1239,
	"./Dummy.sol/Dummy.json": 1240,
	"./DummyFactory.sol/DummyFactory.dbg.json": 1241,
	"./DummyFactory.sol/DummyFactory.json": 1242,
	"./Fallback.sol/Fallback.dbg.json": 1243,
	"./Fallback.sol/Fallback.json": 1244,
	"./FallbackFactory.sol/FallbackFactory.dbg.json": 1245,
	"./FallbackFactory.sol/FallbackFactory.json": 1246,
	"./SpaceBank.sol/IFlashLoanReceiver.dbg.json": 1247,
	"./SpaceBank.sol/IFlashLoanReceiver.json": 1248,
	"./SpaceBank.sol/SpaceBank.dbg.json": 1249,
	"./SpaceBank.sol/SpaceBank.json": 1250,
	"./SpaceBank.sol/SpaceToken.dbg.json": 1251,
	"./SpaceBank.sol/SpaceToken.json": 1252,
	"./SpaceBankFactory.sol/SpaceBankFactory.dbg.json": 1253,
	"./SpaceBankFactory.sol/SpaceBankFactory.json": 1254,
	"./base/Level-05.sol/Level.dbg.json": 1255,
	"./base/Level-05.sol/Level.json": 1256,
	"./base/Level-06.sol/Level.dbg.json": 1257,
	"./base/Level-06.sol/Level.json": 1258,
	"./base/Level-08.sol/Level.dbg.json": 1259,
	"./base/Level-08.sol/Level.json": 1260,
	"./base/Level.sol/Level.dbg.json": 1261,
	"./base/Level.sol/Level.json": 1262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 514;